export default __webpack_public_path__ + "static/media/toc.85555a08.gif";